import { useContext } from 'react';
import CurrencyContext from '../../contexts/CurrencyContext';

export function formatMoney(amount, currency) {
  const limitedAmount = amount < 0 ? 0 : amount;

  if (window.Intl && window.navigator) {
    return new Intl.NumberFormat(window.navigator.language, {
      style: 'currency',
      currency,
    }).format(limitedAmount);
  }

  return `${limitedAmount} ${currency}`;
}

export default ({ amount, currency }) => {
  const ctxCurrency = useContext(CurrencyContext);
  const { currency: _currency, convertPrice } = currency || ctxCurrency;
  return formatMoney(convertPrice(amount), _currency);
};
